import { createSelector } from '@reduxjs/toolkit'
import uniq from 'lodash/uniq'
import selectFocus from './focus'
import selectSelected from './selected'
import * as selectNodes from './nodes'
import * as selectEdges from './edges'

interface FocusState {
  id: string
}

interface SelectedState {
  nodes: Record<string, string>
  edges: Record<string, string>
}

type EntityMap = Record<string, unknown>


export const nodes = createSelector(selectFocus, selectSelected, selectNodes.all, (focus: FocusState, selected: SelectedState, nodes: EntityMap) => {
  const ids = Object.keys(selected.nodes)
  if (nodes[focus.id]) {
    ids.push(focus.id)
  }
  return uniq(ids.filter((id) => nodes[id] != null))
})

export const edges = createSelector(selectFocus, selectSelected, selectEdges.all, (focus: FocusState, selected: SelectedState, edges: EntityMap) => {
  const ids = Object.keys(selected.edges)
  if (edges[focus.id]) {
    ids.push(focus.id)
  }
  return uniq(ids.filter((id) => edges[id] != null))
})
